<template>
<div>
  <v-container> 

        <v-card flat>

            <v-card-title>
              Joining info 
            </v-card-title>
            <v-card-text id="joinInfoWebTxt">
              <span v-html="getJoinInfoWeb()"></span>
            </v-card-text>

            <v-card-text>
            <u>Dial-in</u><br>
            Toronto	647-258-6403<br>
            PIN: {{password()}}
            </v-card-text>

            <v-card-text>
              <a href="#" v-if="showMoreNumbersVar==false" v-on:click="showMoreNumbersVar=true">More numbers</a>
              <a href="#" v-if="showMoreNumbersVar==true" v-on:click="showMoreNumbersVar=false">Less numbers</a>
            </v-card-text>
          
        </v-card>

        <v-card flat v-if="showMoreNumbersVar">
          <v-card-text>
            <u>Other numbers</u> 
          </v-card-text>
          <v-card-text>
            Calgary	403-879-0976<br>
            Montreal	514-254-1278<br>
            Toronto	647-258-6403<br>
            Vancouver	604-221-7022<br>
            New York 917-675-5259<br>
            Los Angelas 323-395-5185<br>
            <v-divider></v-divider>
            United Kingdom	+ 44 (844) 9869671<br>
            France	+ 33 (9) 70777646<br>
          </v-card-text>
        </v-card>

  </v-container>
</div>

</template>

<script >

import ConferenceCommon from '../mixins/conferencecommon';
import Vue from 'vue';

export default Vue.extend({
  data: function() {
    return {
      showMoreNumbersVar: false,
    }
  },
  mixins: [ConferenceCommon],
  props: {showJoiningInfo: Boolean},
  methods: {
    showMoreNumbers: function() {
      this.showMoreNumbersVar = true;
    },
    getJoinInfoWebForCopy: function() {
      let str = 
      "https://join.rinble.com/" + this.getBestGuestPin() + "\n" +
      "Password: " + this.password();
      return str;
    }
  },
  computed: {
   
  },
  async mounted() {
    
  },
  watch: {

  }
})
</script>
